import Image from "next/image";
import { course as items } from "../../../shared/utils/faq";
import Collapsible from "react-collapsible";
import styles from "../faq.module.scss";

export default function Course() {
  const course = items.slice(1);
  const item = items[0];
  const handleOpen = (index: number) => {
    const arrow = document.querySelector(`.arrowCourse${index}`);
    arrow?.classList.toggle(styles.active);
  };
  return (
    <div className={styles.questionWrapper} data-aos="fade-down">
      <h2 className={styles.title}>02. Curso</h2>

      <Collapsible
        trigger={
          <div className={styles.questionTitle} onClick={() => handleOpen(0)}>
            <h3>{item.title}</h3>
            <Image
              src="/images/arrow-down.svg"
              alt="Ícone de pergunta"
              width="23"
              height="14"
              className={`arrowCourse${0}`}
            />
          </div>
        }
        className={styles.dropdown}
      >
        <article className={styles.question}>
          <div>
            <p>{item.paragraph}</p>
          </div>
        </article>
      </Collapsible>

      {course.map((item, index) => (
        <div key={`${item.title + index}`}>
          <Collapsible
            trigger={
              <div
                className={styles.questionTitle}
                onClick={() => handleOpen(index + 2)}
              >
                <h3>{item.title}</h3>
                <Image
                  src="/images/arrow-down.svg"
                  alt="Ícone de pergunta"
                  width="23"
                  height="14"
                  className={`arrowCourse${index + 2}`}
                />
              </div>
            }
            className={styles.dropdown}
          >
            <article className={styles.question}>
              <div>
                <p>{item.paragraph}</p>
              </div>
            </article>
          </Collapsible>
        </div>
      ))}

      <Collapsible
        trigger={
          <div
            className={styles.questionTitle}
            onClick={() => handleOpen(course.length + 2)}
          >
            <h3>Qual o equipamento necessário?</h3>
            <Image
              src="/images/arrow-down.svg"
              alt="Ícone de pergunta"
              width="23"
              height="14"
              className={`arrowCourse${course.length + 2}`}
            />
          </div>
        }
        className={styles.dropdown}
      >
        <article className={styles.question}>
          <div>
            <p>
              Cada aluno deve utilizar seu próprio computador durante as aulas.
              Segue abaixo alguns requisitos importantes:
            </p>
            <ul>
              <li>Acesso à internet</li>
              <li>Idade: Quatro anos ou menos</li>
              <li>Memória: Pelo menos 8 GB</li>
              <li>Processador: Pelo menos 1.4 GHz</li>
              <li>Armazenamento: Pelo menos 256 GB (SSD é recomendado)</li>
              <li>Sistema Operacional: Ubuntu 20.04, macOS ou Windows</li>
              <li>
                Confira a{" "}
                <a
                  href="https://ubuntu.com/certified?category=Desktop&level=&release=18.04+LTS&q="
                  target="_blank"
                  rel="noreferrer"
                >
                  lista de modelos já certificados para Ubuntu
                </a>
              </li>
            </ul>
          </div>
        </article>
      </Collapsible>
    </div>
  );
}
